class AutoFreeGift extends HTMLElement {
    constructor() {
        super();
        this.threshold = parseInt(this.dataset.threshold);
        this.variantId = this.dataset.variantId;

        // Run on initialization
        this.checkAndAdd();

        // Listen for cart updates
        document.addEventListener('cart:refresh', () => this.checkAndAdd());
        document.addEventListener('cart:change', () => this.checkAndAdd());
    }

    async checkAndAdd() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            // Calculate total after discounts
            let total = 0;
            for (const item of cart.items) {
                total += item.final_line_price;
            }

            // Check if free gift is already in cart (auto-added)
            const hasAutoGift = cart.items.some(item =>
                item.variant_id == this.variantId &&
                item.properties &&
                item.properties._auto_free_gift === 'true'
            );

            // Check if user manually added the product
            const hasManualProduct = cart.items.some(item =>
                item.variant_id == this.variantId &&
                (!item.properties || !item.properties._auto_free_gift)
            );

            if (total >= this.threshold && !hasAutoGift && !hasManualProduct) {
                // Add the free gift with a hidden property
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: this.variantId,
                        quantity: 1,
                        properties: {
                            '_auto_free_gift': 'true'
                        }
                    })
                });

                // Refresh cart UI
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            } else if (total < this.threshold && hasAutoGift) {
                // Remove the auto-added gift if threshold not met
                const giftItem = cart.items.find(item =>
                    item.variant_id == this.variantId &&
                    item.properties &&
                    item.properties._auto_free_gift === 'true'
                );

                if (giftItem) {
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: giftItem.key,
                            quantity: 0
                        })
                    });

                    // Refresh cart UI
                    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                }
            }
        } catch (error) {
            console.error('Auto free gift error:', error);
        }
    }
}

customElements.define('auto-free-gift', AutoFreeGift);
